var fetcher = {};
export {
  fetcher as __exports
};
//# sourceMappingURL=fetcher2.js.map
